import React from 'react';
import { useQuery } from 'react-query';

import MuiTable from '@material-ui/core/Table';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import { Link } from 'react-router-dom';
import sortBy from 'lodash/sortBy';
import * as API from 'api';
import { formatCurrency } from '../RecoupAccounts';

const RecoupAccounts = API.RecoupAccounts();
function RecoupmentAccount({ account, isOpen }) {
  const { name, id } = account;
  const { data, isLoading } = useQuery(['recoup-account', id], () => RecoupAccounts.getById(id, { preview: true }), {
    enabled: !!id && isOpen,
  });

  if (isLoading)
    return (
      <MuiTableRow>
        <MuiTableCell colSpan="2">
          <MuiCircularProgress />
        </MuiTableCell>
      </MuiTableRow>
    );

  return (
    <MuiTableRow>
      <MuiTableCell>
        <Link to={`/recoupment-account/${id}`}>{name}</Link>
      </MuiTableCell>
      <MuiTableCell align="right">{formatCurrency(data?.committed_usd)}</MuiTableCell>
    </MuiTableRow>
  );
}

export default function LabelAccounts({ accounts, isOpen }) {
  return (
    <MuiTableRow>
      <MuiTableCell colSpan="2" style={{ paddingLeft: '2rem' }}>
        <MuiTable>
          <MuiTableHead>
            <MuiTableRow>
              <MuiTableCell>Recoup Account Name</MuiTableCell>
              <MuiTableCell align="right">Committed</MuiTableCell>
            </MuiTableRow>
          </MuiTableHead>
          <MuiTableBody>
            {sortBy(accounts, ['name']).map((account, i) => (
              <RecoupmentAccount key={i} account={account} />
            ))}
          </MuiTableBody>
        </MuiTable>
      </MuiTableCell>
    </MuiTableRow>
  );
}
